export default {
  props: ['show', 'title', 'message'],
  emits: ['go-to-next', 'go-to-previous'],
  methods: {
    onButtonClicked () {
      this.$emit('button-clicked')
    }
  },
  template: `
    <div class="error-layer" :class="{hidden: !show}">
        <div class="error-layer__modal">
            <p class="application__headline">{{ title || 'Oops, hier ist etwas schiefgelaufen!' }}</p>

            <template v-if="message">
                <div v-html="message"></div>
            </template>
            <template v-else>
                <p>
                    Beim Speichern Ihrer Mitgliedserklärung meldet unser System einen Fehler. Das kann verschiedene Gründe
                    haben. Leider muss der Vorgang hier abgebrochen werden. Dies tut uns sehr leid.
                </p>

                <p>
                    Bitte kontaktieren Sie unseren Wechselservice unter der Telefonnummer <a href="tel:+4952152283752">0521
                    5228-3752</a>. Die Kolleginnen und Kollegen helfen Ihnen schnell und unkompliziert weiter – montags bis
                    donnerstags von 09:00 Uhr bis 17:00 Uhr und freitags von 09:00 Uhr bis 16:00 Uhr.
                </p>

                <p>
                    Alternativ können Sie uns auch gerne eine E-Mail schreiben an: <a
                        href="mailto:wechselservice@bkkgs.de?subject=Online-ME%3A%20Fehler%20Daten%C3%BCbertragung%20Website"
                        title="wechselservice@bkkgs.de">wechselservice@bkkgs.de</a>
                </p>
            </template>
            <p>
                Ihre BKK GILDEMEISTER SEIDENSTICKER
            </p>

            <button class="btn btn--secondary" @click="onButtonClicked">Schließen und zur Startseite</button>
        </div>
    </div>
    `
}
